import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements} from 'react-router-dom';
import { BASENAME } from '../config';

import { CartProvider } from './context/cart-context/cart-context';
import { Layout } from '../components/layout/layout';
import { Catalog, catalogLoader } from '../components/catalog/catalog';
import { Cart } from '../components/cart/cart';
import { History, historyLoader } from '../components/history/history';
import { Search } from '../components/search/search';
import { Shipping } from '../components/shipping/shipping';
import { Checkout, checkoutLoader } from '../components/checkout/checkout';
import { Product, productLoader } from '../components/catalog/product/product';

import './App.css';
import { Completed } from '../components/history/tabs/completed';


const router = createBrowserRouter(createRoutesFromElements(
  <Route path={`/`} element={<Layout />} >
    <Route index element={<Catalog />} loader={catalogLoader}/>
    <Route path="product/:id" element={<Product/>} loader={productLoader} />
    <Route path='cart' element={<Cart />}/>
    <Route path='history/*' element={<History />} loader={historyLoader}>
        <Route path='completed' element={<Completed/>}/>
    </Route>
    <Route path='search' element={<Search />} />
    <Route path='shipping' element={<Shipping />}  />
    <Route path='checkout' element={<Checkout />} loader={checkoutLoader} />
  </Route>
), {basename: BASENAME})


function App() {

  return (
    <>
        <CartProvider>
          <RouterProvider router={router}/>
        </CartProvider>
    </>
  );
}

export default App;
